module.exports = __webpack_public_path__ + "56a8ea16ab3aee1850b7124214d1b2a9.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-23.png
// module id = 2071
// module chunks = 0